/**
 * jQuery UI Accordion
 *
 * @see https://jqueryui.com/accordion/
 */
jQuery( function ( $ ) {
	$( '.ui-accordion' ).accordion( {
		collapsible: true,
		heightStyle: 'content',
		active: false,
	} );
} );
